<template>
	<div>
		<Header />
		<AdvanceSearchMobile />
	</div>
</template>

<script>
import AdvanceSearchMobile from '@/components/search/mobile/SearchMobile';
import Header from '@/components/ui/header';
export default {
	name: 'mobileAdvanceSearch',
	components: {
		Header,
		AdvanceSearchMobile
	}
};
</script>
